var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(1.632 1.6339)","label":"Layer 1"},[React.createElement("path",{"d":"m-2.5783e-4 -0.0014681 17.436 18.214","fill":"#5f6368","stroke":"#5f6368","strokeLinecap":"round","strokeWidth":"3.2316","key":0}),React.createElement("path",{"d":"m-2.5783e-4 18.212 17.436-18.214","fill":"#5f6368","stroke":"#5f6368","strokeLinecap":"round","strokeWidth":"3.2316","key":1}),React.createElement("title",{"key":2},"Layer 1")]));
}

Cross.defaultProps = {"version":"1.1","viewBox":"0 0 20.699 21.479"};

module.exports = Cross;

Cross.default = Cross;
